import { render, staticRenderFns } from "./InsuranceBtn.vue?vue&type=template&id=5d04ccc9"
import script from "./InsuranceBtn.vue?vue&type=script&lang=js"
export * from "./InsuranceBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports